import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaisRiesgoService {
  /**
   * @description Constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Recuperar pais de riesgo
   * @params paisName
   */
  getCountryRisk(paises: string[]): Observable<any> {
    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };

    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.paisRiesgo.name,
      paises,
      httpOpt
    );
  }

}
